export default {
    cards: [],
    currentCard: {},
    jid: "",
    amount: 0,
    url: ""
}